namespace advisorop.components.advisor {

    export class AdvisorCrmGridController {

        // input
        advisor: domains.IAdvisor = { id: 0 };

        // state
        crmMappings: domains.IAdvisorCrmViewModel[] = [];
        externalSystems: domains.IAdvisorExternalSystem[] = [];
        loading = false;
        showEditForm = false;
        editModel: domains.IAdvisorCrmViewModel = { id: 0 };
        externalUsers: any[] = [];
        selExternalSystem: domains.IAdvisorExternalSystem = {};
        selExternalUser: any = null;
        user: domains.identity.IUser;
        loadingUsers = false;

        // Cached user lists per external system
        private cachedSalesforceUsers: any[] = null;
        private cachedOrionUsers: any[] = null;

        gridOptions: DevExpress.ui.dxDataGridOptions;

        static $inject = ["advisorService", "generalService", "servicerService", "identityService", "$scope"];
        constructor(
            private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private servicerService: services.ServicerService,
            private identityService: services.IdentityService,
            private $scope: ng.IScope
        ) { }

        $onInit() {
            this.identityService.getUserPromise()
                .then(response => this.user = response);
            this.initGrid();
        }

        $onChanges(event): void {
            for (var key in event) {
                if (key === "advisor") {
                    if (this.advisor && this.advisor.id > 0) {
                        this.loadExternalSystems();
                        this.preloadExternalUsers();
                        this.loadCrmMappings();
                    }
                }
            }
        }

        initGrid(): void {
            this.gridOptions = {
                bindingOptions: {
                    dataSource: "vm.crmMappings"
                },
                columns: [
                    {
                        dataField: "externalSystemName",
                        caption: "External System",
                        width: "30%"
                    },
                    {
                        dataField: "externalUserDisplayName",
                        caption: "External User",
                        width: "30%"
                    },
                    {
                        dataField: "externalSystemAdvisorId",
                        caption: "External User ID",
                        width: "25%"
                    },
                    {
                        caption: "Actions",
                        width: "15%",
                        cellTemplate: "actionsCellTemplate",
                        allowSorting: false,
                        allowFiltering: false
                    }
                ],
                showBorders: true,
                showRowLines: true,
                rowAlternationEnabled: true,
                columnAutoWidth: false,
                noDataText: "No external system mappings configured",
                paging: {
                    enabled: false
                }
            };
        }

        loadCrmMappings(): void {
            this.loading = true;
            this.advisorService.getAdvisorCrms(this.advisor.id)
                .then(response => {
                    this.crmMappings = response.data || [];
                    this.resolveExternalUserNames();
                    this.loading = false;
                })
                .catch(err => {
                    this.generalService.showError(err);
                    this.loading = false;
                });
        }

        private preloadExternalUsers(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                // Pre-load Salesforce users
                if (!this.cachedSalesforceUsers) {
                    let sfPromise: ng.IHttpPromise<any[]>;
                    if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
                        const cgId = this.advisor.companyGroup ? this.advisor.companyGroup.id : 0;
                        sfPromise = this.servicerService.loadSalesforceUsers(cgId);
                    } else {
                        sfPromise = this.advisorService.loadSalesforceUsers();
                    }
                    sfPromise.then(data => {
                        this.cachedSalesforceUsers = data.data || [];
                        this.resolveExternalUserNames();
                    }).catch(() => {});
                }
                // Pre-load Orion users
                if (!this.cachedOrionUsers) {
                    let orionPromise: ng.IHttpPromise<any[]>;
                    if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
                        const cgId = this.advisor.companyGroup ? this.advisor.companyGroup.id : 0;
                        orionPromise = this.servicerService.loadOrionRepresentatives(cgId);
                    } else {
                        orionPromise = this.advisorService.loadOrionRepresentatives();
                    }
                    orionPromise.then(data => {
                        this.cachedOrionUsers = (data.data || []).map(r => ({ Id: String(r.id), Username: r.fullName }));
                        this.resolveExternalUserNames();
                    }).catch(() => {});
                }
            });
        }

        private resolveExternalUserNames(): void {
            if (!this.crmMappings || this.crmMappings.length === 0) return;
            for (const crm of this.crmMappings) {
                (crm as any).externalUserDisplayName = this.lookupUserName(crm.externalSystemId, crm.externalSystemAdvisorId);
            }
        }

        private lookupUserName(externalSystemId: number, externalUserId: string): string {
            if (!externalUserId) return "";
            if (externalSystemId === domains.ExternalSystem.SALESFORCE && this.cachedSalesforceUsers) {
                const user = this.cachedSalesforceUsers.filter(x => x.Id === externalUserId)[0];
                return user ? (user.Username || user.Email || externalUserId) : externalUserId;
            }
            if (externalSystemId === domains.ExternalSystem.ORION && this.cachedOrionUsers) {
                const user = this.cachedOrionUsers.filter(x => x.Id == externalUserId)[0];
                return user ? user.Username : externalUserId;
            }
            return externalUserId;
        }

        loadExternalSystems(): void {
            this.loadExternalSystemsThen(null);
        }

        loadExternalSystemsThen(callback: () => void): void {
            let extSysPromise: ng.IHttpPromise<domains.IAdvisorExternalSystem[]>;
            console.log("User", JSON.stringify(this.user));
            //if (this.user && this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
                extSysPromise = this.generalService.getExternalSystems();
            // } else {
            //     extSysPromise = this.advisorService.getExternalSystems();
            // }

            extSysPromise.then(data => {
                this.externalSystems = data.data;
                if (callback) callback();
            }).catch(err => {
                console.log("Error loading external systems", err);
            });
        }

        addNew(): void {
            this.editModel = {
                id: 0,
                advisorId: this.advisor.id,
                companyGroupId: this.advisor.companyGroup ? this.advisor.companyGroup.id : undefined,
                externalSystemId: null,
                externalSystemAdvisorId: null
            };
            this.selExternalSystem = {};
            this.selExternalUser = null;
            this.externalUsers = [];
            this.showEditForm = true;
        }

        editCrm(crm: domains.IAdvisorCrmViewModel): void {
            if (!crm) return;
            this.editModel = angular.copy(crm);
            this.selExternalUser = null;
            this.externalUsers = [];
            this.showEditForm = true;

            // Pre-select external system and load its users
            if (this.externalSystems && this.externalSystems.length > 0 && this.editModel.externalSystemId) {
                this.selExternalSystem = this.externalSystems.filter(x => x.id === this.editModel.externalSystemId)[0] || {};
                this.externalSystemChanged(true);
            } else if (this.editModel.externalSystemId) {
                // External systems not loaded yet — load them first, then bind
                this.loadExternalSystemsThen(() => {
                    this.selExternalSystem = this.externalSystems.filter(x => x.id === this.editModel.externalSystemId)[0] || {};
                    this.externalSystemChanged(true);
                });
            }
        }

        cancelEdit(): void {
            this.showEditForm = false;
            this.editModel = { id: 0 };
            this.selExternalSystem = {};
            this.selExternalUser = null;
            this.externalUsers = [];
        }

        deleteCrm(crm: domains.IAdvisorCrmViewModel): void {
            if (!confirm("Are you sure you want to remove this external system mapping?")) {
                return;
            }

            this.loading = true;
            this.advisorService.deleteAdvisorCrm(crm.id)
                .then(() => {
                    toastr.success("External system mapping removed.");
                    this.loadCrmMappings();
                })
                .catch(err => {
                    this.generalService.showError(err);
                    this.loading = false;
                });
        }

        externalSystemChanged(bindExisting = false): void {
            this.editModel.externalSystemId = this.selExternalSystem.id;
            this.externalUsers = [];
            this.selExternalUser = null;

            if (this.editModel.externalSystemId === domains.ExternalSystem.SALESFORCE) {
                this.loadSalesforceUsers(bindExisting);
            } else if (this.editModel.externalSystemId === domains.ExternalSystem.ORION) {
                this.loadOrionRepresentatives(bindExisting);
            }
        }

        externalUserChanged(): void {
            if (this.selExternalUser) {
                this.editModel.externalSystemAdvisorId = this.selExternalUser.Id;
            }
        }

        loadSalesforceUsers(bindExisting = false): void {
            if (this.cachedSalesforceUsers) {
                this.externalUsers = this.cachedSalesforceUsers;
                if (bindExisting && this.editModel.externalSystemAdvisorId) {
                    this.selExternalUser = this.externalUsers.filter(x => x.Id === this.editModel.externalSystemAdvisorId)[0];
                }
                return;
            }

            this.loadingUsers = true;
            let promise: ng.IHttpPromise<any[]>;
            if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
                const cgId = this.advisor.companyGroup ? this.advisor.companyGroup.id : 0;
                promise = this.servicerService.loadSalesforceUsers(cgId);
            } else {
                promise = this.advisorService.loadSalesforceUsers();
            }

            promise.then(data => {
                this.cachedSalesforceUsers = data.data || [];
                this.externalUsers = this.cachedSalesforceUsers;
                this.loadingUsers = false;
                if (bindExisting && this.editModel.externalSystemAdvisorId) {
                    this.selExternalUser = this.externalUsers.filter(x => x.Id === this.editModel.externalSystemAdvisorId)[0];
                }
            }).catch(err => {
                this.loadingUsers = false;
                this.generalService.showError(err);
            });
        }

        loadOrionRepresentatives(bindExisting = false): void {
            if (this.cachedOrionUsers) {
                this.externalUsers = this.cachedOrionUsers;
                if (bindExisting && this.editModel.externalSystemAdvisorId) {
                    this.selExternalUser = this.externalUsers.filter(x => x.Id == this.editModel.externalSystemAdvisorId)[0];
                }
                return;
            }

            this.loadingUsers = true;
            let promise: ng.IHttpPromise<any[]>;
            if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
                const cgId = this.advisor.companyGroup ? this.advisor.companyGroup.id : 0;
                promise = this.servicerService.loadOrionRepresentatives(cgId);
            } else {
                promise = this.advisorService.loadOrionRepresentatives();
            }

            promise.then(data => {
                this.cachedOrionUsers = (data.data || []).map(r => ({ Id: String(r.id), Username: r.fullName }));
                this.externalUsers = this.cachedOrionUsers;
                this.loadingUsers = false;
                if (bindExisting && this.editModel.externalSystemAdvisorId) {
                    this.selExternalUser = this.externalUsers.filter(x => x.Id == this.editModel.externalSystemAdvisorId)[0];
                }
            }).catch(err => {
                this.loadingUsers = false;
                this.generalService.showError(err);
            });
        }

        saveCrm(): void {
            if (!this.editModel.externalSystemId || !this.editModel.externalSystemAdvisorId) {
                toastr.warning("Please select an external system and user.");
                return;
            }

            this.loading = true;
            this.advisorService.saveAdvisorCrm(this.editModel)
                .then(() => {
                    toastr.success("External system mapping saved.");
                    this.showEditForm = false;
                    this.editModel = { id: 0 };
                    this.loadCrmMappings();
                })
                .catch(err => {
                    this.generalService.showError(err);
                    this.loading = false;
                });
        }
    }

    class AdvisorCrmGrid implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisor: "<"
            };
            this.controller = AdvisorCrmGridController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/advisor-crm-grid.html";
        }
    }

    angular.module(Constants.APP).component("advisorCrmGrid", new AdvisorCrmGrid());
}
